<template>
    <div class="divWrap">
        <el-form ref="form" 
        :rules="rules"
        :model="formData" label-width="80px" :inline="false" label-position="right">
            <div class="divFormWrap">
                <div class="divInlineBlockBox">
                    <div class="divInlineBlock">
                        <el-form-item label="发券时间">
                            <el-date-picker
                                v-model="formData.sendCouponTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                            >
                            </el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="券面额">
                            <el-select v-model="formData.couponAmount" placeholder="请选择券面额">
                                <el-option value="" label="全部"></el-option>
                                <el-option v-for="(item, index) in this.getcouponAmounts" :key="index" :label="item" :value="item" ></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="券批次" prop="batchId">
                            <el-input class="el-input-change" v-model.trim="formData.batchId"></el-input>
                        </el-form-item>
                        <el-form-item label="发券人">
                            <el-input class="el-input-change" v-model.trim="formData.createName"></el-input>
                        </el-form-item>
                    </div>
                    <div class="divInlineBlock">
                        <el-form-item label="券类型">
                            <el-select v-model="formData.productId" placeholder="请选择券类型">
                                <el-option value="" label="全部"></el-option>
                                <el-option
                                    v-for="item in getComboBoxByType"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发放方式">
                            <el-select v-model="formData.directionType" placeholder="请选择发放方式">
                                <el-option value="" label="全部"></el-option>
                                <!-- todo pm label 名 -->
                                <el-option label="API" value="3"></el-option>
                                <el-option label="自主手机号" value="4"></el-option>
                                <el-option label="自主批量" value="5"></el-option>
                                <el-option label="渠道红包" value="7"></el-option>
                                <el-option label="兑换码" value="8"></el-option>
                                <el-option label="H5发放" value="9"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button
                        class="downLoadBtn"
                        @click="onDownLoad"
                        :loading ='downLoading'
                        >下载</el-button>
                </el-form-item>
            </div>
        </el-form>
        <el-table
            :data="getSendCouponInfos.dataList"
            v-loading="sendCouponInfosLoading"
            stripe
            style="width: 100%">
            <el-table-column
                prop="createTimeStr"
                label="发券时间"
                width="150px"
            >
            </el-table-column>
            <el-table-column
                prop="phones"
                label="用户手机号"
                width="125px"
            >
            </el-table-column>
            <el-table-column
                prop="productName"
                label="券类型"
            >
            </el-table-column>
            <el-table-column
                prop="batchId"
                label="券批次"
                width="125px"
            ></el-table-column>
            <el-table-column
                prop="couponName"
                label="券名称"
            >
            <template slot-scope="scope">
                <el-tooltip placement="top" effect="light">
                    <div slot="content">
                        <CouponCard
                            :validity="scope.row.expireTimeStr" :price="scope.row.couponAmount"
                            :tip="scope.row.couponExplain" :couponname="scope.row.couponName"
                            :coupontype="scope.row.productName"
                            :width=335 :height=122
                            padding="15px 12px"
                            nameSize="18px"  priceSize="41px"
                            status="1"
                        />
                    </div>
                    <a>{{scope.row.couponName}}</a>
                </el-tooltip>
            </template>
            </el-table-column>
            <el-table-column
                prop="couponAmount"
                label="券面额(元)"
                width="110px"
            >
            </el-table-column>
            <el-table-column
                prop="sendNumber"
                label="发券数量(张)"
                width="120px"
            >
            </el-table-column>
            <el-table-column
                prop="createName"
                label="发券人"
            >
            </el-table-column>
            <el-table-column
                prop="directionTypeStr"
                label="发券方式"
            >
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.status===0">
                        <div class="divSqureRed"></div>
                        <span class="status_txt">发送中</span>
                    </div>
                    <div v-else-if="scope.row.status===1">
                        <div class="divSqureGreen"></div>
                        <span class="status_txt">成功</span>
                    </div>
                    <div v-else-if="scope.row.status===2">
                        <div class="divSqureRed"></div>
                        <span class="status_txt">部分成功</span>
                    </div>
                    <div v-else-if="scope.row.status===3">
                        <div class="divSqureRed"></div>
                        <span class="status_txt">失败</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="option"
                label="操作"
                width="175px"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.status===1">
                        <a href="javascript:void(0)" @click="dialogShow(scope.row.id, scope.row.tradeId)">详情</a>
                    </div>
                    <div v-else-if="scope.row.status===2">
                        <a href="javascript:void(0)" @click="dialogShow(scope.row.id, scope.row.tradeId)">详情</a>&emsp;
                        <a href="javascript:void(0)" @click="downloadFail(scope.row.id, scope.row.tradeId)">下载失败手机号</a>
                    </div>
                    <div v-else-if="scope.row.status===3">
                        <a href="javascript:void(0)" @click="downloadFail(scope.row.id, scope.row.tradeId)">下载失败手机号</a>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="getSendCouponInfosSizeChange"
            @current-change="getSendCouponInfosCurrentChange"
            :current-page="getSendCouponInfos.pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="20"
            layout="total, prev, pager, next, sizes"
            :total="getSendCouponInfos.total"
            class="el-pagenation"
            background
        >
        </el-pagination>

        <el-dialog title="发券详情" :visible.sync="dialogTableVisible" top="0" width="60%">
            <el-table
                :data="getSendCouponRecords.dataList"
                stripe
                v-loading="sendCouponRecordsLoading"
            >
                <el-table-column property="couponId" label="券号"></el-table-column>
                <el-table-column property="phone" label="手机号"></el-table-column>
                <el-table-column width="90px" property="isUsed" label="是否使用">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isUsed===1">
                            <span>是</span>
                        </div>
                        <div v-else-if="scope.row.isUsed===0">
                            <span>否</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="165px" property="expireTime" label="过期时间"></el-table-column>
                <el-table-column property="beginChargeTime" label="行程开始时间"></el-table-column>
                <el-table-column property="finishedTime" label="行程结束时间"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="getSendCouponRecordsSizeChange"
                @current-change="getSendCouponRecordsCurrentChange"
                :current-page="getSendCouponRecords.pageNum"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="10"
                layout="total, prev, pager, next, sizes"
                :total="getSendCouponRecords.total"
                class="el-pagenation"
                background
            >
            </el-pagination>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'

import CouponCard from '../../components/CouponCard'

export default {
  name: 'sendCouponHistory',
  componentName: 'sendCouponHistory',
  data () {
    let checkBatchId = (rule, value, callback) => {
      if(value){
        if (isNaN(value)) {
            callback(new Error('请输入数字'))
            return
        }
        let valueNumber = Number(value)
        if (!Number.isInteger(valueNumber)) {
            callback(new Error('请输入正整数'))
            return
        } 
        if(valueNumber <=0){
            callback(new Error('请输入正整数'))
            return
        }
        callback()
      }else{
        callback()
      }
    }
    return {
      couponType: '',
      dialogTableVisible: false,
      formData: {
        groupId: this.$store.state.header.selfGroup ? this.$store.state.header.selfGroup.groupId : '',
        startTime: '',
        endTime: '',
        productId: '',
        couponAmount: '',
        directionType: '',
        couponName: '',
        batchId:'',
        createName: '',
        pageNum: 1,
        pageSize: 20,
        sendCouponTime: []
      },
      getSendCouponRecordsFormData: {
        groupId: this.$store.state.header.selfGroup ? this.$store.state.header.selfGroup.groupId : '',
        tradeId: '',
        pageNum: 1,
        pageSize: 10
      },
      rules:{
            batchId:[
                { validator: checkBatchId, trigger: 'change'}
            ]
        }
    }
  },
  methods: {
    onSubmit () {
        this.$refs.form.validate((valid) => {
            if (valid) {
                this.getCouponHistoryData(1)
            } else {
            return false
            }
        })
    },
    getCouponHistoryData (pageNum) {
      if (pageNum) {
        this.formData.pageNum = pageNum
      }
      let sendCouponTime = this.formData.sendCouponTime || []
      this.formData.startTime = sendCouponTime && sendCouponTime[0] ? sendCouponTime[0] : ''
      this.formData.endTime = sendCouponTime && sendCouponTime[1] ? sendCouponTime[1] : ''
      this.$store.dispatch('sendCouponHistory/getSendCouponInfos', this.formData)
    },
    onDownLoad () {
        this.$refs.form.validate((valid) => {
            if (valid) {
                const {groupId, startTime = '', endTime = '', productId, couponAmount, directionType, couponName, createName} = this.formData
                this.$store.dispatch('sendCouponHistory/downloadSendCouponInfos', {groupId, startTime, endTime, productId, couponAmount, directionType, couponName, createName})
            } else {
            return false
            }
        })
    },
    getSendCouponInfosSizeChange (pageSize) {
      this.formData.pageSize = pageSize
      this.getCouponHistoryData()
    },
    getSendCouponInfosCurrentChange (pageNum) {
      this.formData.pageNum = pageNum
      this.getCouponHistoryData()
    },
    dialogShow (id, tradeId) {
      this.dialogTableVisible = true
      this.getSendCouponRecordsFormData.id = id
      this.getSendCouponRecordsFormData.tradeId = tradeId
      this.$store.dispatch('sendCouponHistory/getSendCouponRecords', this.getSendCouponRecordsFormData)
    },
    getSendCouponRecordsSizeChange (pageSize) {
      this.getSendCouponRecordsFormData.pageSize = pageSize
      this.$store.dispatch('sendCouponHistory/getSendCouponRecords', this.getSendCouponRecordsFormData)
    },
    getSendCouponRecordsCurrentChange (pageNum) {
      this.getSendCouponRecordsFormData.pageNum = pageNum
      this.$store.dispatch('sendCouponHistory/getSendCouponRecords', this.getSendCouponRecordsFormData)
    },
    downloadFail (id, tradeId) {
      let requestData = {
        id,
        tradeId,
        groupId: this.formData.groupId
      }
      this.$store.dispatch('sendCouponHistory/downloadFailPhonesFile', requestData)
    }
  },
  computed: mapState({
    getSendCouponInfos: state => {
      let sendCouponInfos = state.sendCouponHistory.sendCouponInfos
      return sendCouponInfos
    },
    getSendCouponRecords: state => {
      let sendCouponRecords = state.sendCouponHistory.sendCouponRecords
      return sendCouponRecords
    },
    getComboBoxByType: state => {
      let comboBoxByType = state.sendCouponHistory.comboBoxByType
      return comboBoxByType
    },
    getcouponAmounts: state => {
      let couponAmounts = state.sendCouponHistory.couponAmounts
      return couponAmounts
    },
    sendCouponInfosLoading: state => state.sendCouponHistory.sendCouponInfosLoading,
    sendCouponRecordsLoading: state => state.sendCouponHistory.sendCouponRecordsLoading,
    downLoading: state => state.sendCouponHistory.downLoading,
    creatDownloadTaskSuccess: state => state.sendCouponHistory.creatDownloadTaskSuccess,
    creatDownloadTaskFail: state => state.sendCouponHistory.creatDownloadTaskFail
  }),
  watch: {
    dialogTableVisible (val) {
      if (!val) {
        this.$store.dispatch('sendCouponHistory/initState', 'sendCouponRecords')
      }
    },
    creatDownloadTaskSuccess (val) {
      if (val) {
        this.$message({
          showClose: false,
          message: '新建下载任务成功，请点击任务中心查看',
          type: 'success'
        })
        this.$store.dispatch('sendCouponHistory/initState', 'creatDownloadTaskSuccess')
      }
    },
    creatDownloadTaskFail () {
      if (val) {
        this.$message({
          showClose: false,
          message: '新建下载任务失败，请稍后在试',
          type: 'error'
        })
        this.$store.dispatch('sendCouponHistory/initState', 'creatDownloadTaskFail')
      }
    }
  },
  mounted () {
    this.$store.dispatch('sendCouponHistory/getComboBoxByType', { type: '0' })
    this.$store.dispatch('sendCouponHistory/getSendCouponInfos', this.formData)
    this.$store.dispatch('sendCouponHistory/getCouponAmounts')
    this.omgTrack('es_chuxingquan_xieyi_share_history_sw', '出行券模块进入发券历史')
  },
  components: {
    CouponCard
  }
}
</script>

<style lang="stylus">
    inlineBlock()
        display: inline-block;
    .el-tooltip__popper.is-light {
        box-shadow: 0 -4px 14px 0 rgba(0,0,0,0.10);
        border: none;
        border-radius: 1px;
    }
    .el-tooltip__popper .popper__arrow {
        border-width: 0px;
    }
    .popper__arrow::before, .popper__arrow::after {
        border: solid transparent;
        content: ' ';
        height: 0;
        position: absolute;
        width: 0;
    }
    .divWrap {
        padding: 30px;
        .divFormWrap {
            padding: 0 20px;
            .divInlineBlockBox{
                display:flex;
                .divInlineBlock {
                    width: 50%;
                }    
            }
            
            .el-input-change {
                width: 200px;
            }
        }
        .el-button--primary {
            padding: 12px 20px;
        }
        .divSqureGreen {
            inlineBlock();
            width: 6px;
            height: 6px;
            background-color: #4DBF84;
        }
        .divSqureRed {
            inlineBlock();
            width: 6px;
            height: 6px;
            background-color: #FF8252;
        }
        .status_txt{
            vertical-align: -2px;
            margin-left: 6px;
        }
        .el-pagenation {
            text-align: right;
            margin-top: 10px;
        }
        .el-dialog__wrapper {
            overflow: hidden;
        }
        .el-dialog {
            position: absolute;
            right: 0;
            height: 100%;
            overflow-y: auto;

            .el-dialog__header {
                padding: 20px 40px 0px;

                .el-dialog__title {
                    font-weight: 500;
                }
            }
            .el-dialog__body {
                padding: 20px 40px;

                .el-pagination.is-background .el-pager li:not(.disabled).active {
                    background-color: #3468ff;
                }
            }
        }
        .el-tooltip__popper.is-light {
            box-shadow: 0 1px 6px 0;
        }
        td:last-child .cell {
            padding-right: 20px;
        }
        .cell a {
            color: blue;
            width: initial;
        }
        .cell a.el-tooltip {
            color: #666;
        }
    }
    .downLoadBtn{
        position: absolute;
        top: 5px;
        right: 3px;
    }
    .el-button.is-loading{
        position: absolute;
    }
</style>
